import moment from 'moment';

import {
  GET_SEARCH_RESULTS,
  DATA_CLEAR_SEARCH_RESULTS,
  GET_SEARCH_RESULTS_MAP,
  DATA_CLEAR_SEARCH_RESULTS_MAP,
  DATA_SEARCH_TOGGLE_BIKE_TYPE,
  DATA_SEARCH_INCLUDE_BIKE_TYPES,
  DATA_SEARCH_SET_BOOKING_PERIOD,
  DATA_SEARCH_SET_SEARCH_PARAMS,
  DATA_SEARCH_INIT_SEARCH
} from '../constants';

import {
  selectBookingPeriod,
  selectSearchQuery
} from '../selectors';

import {
  getDefaultBookingDate,
  getDefaultDropDate,
  extractSearchParams,
  updateBookingBeginDate,
  updateBookingEndDate,
  updateBookingBeginDay,
  updateBookingEndDay
} from '../utils';

export function loadSearchResults(params) {
  return (dispatch, getState) => {
    const queryParams = { ...params };

    const currentPage = getState().search.searchResults;

    // TODO: This might cause some issues w/ incorrected UI|Results state.
    // We should abort previous request instead of a new one.
    if (currentPage.isFetching) {
      return;
    }

    const nextPage = currentPage.items ? currentPage.items.nextPage : 1;

    if (!nextPage) {
      return;
    }

    queryParams.page = nextPage;
    queryParams.page_size = 25;

    return dispatch({
      type: GET_SEARCH_RESULTS,
      meta: {
        method: 'GET',
        queryParams,
        endpoint: 'bikes/'
      }
    });
  };
}

export function clearSearchResults() {
  return dispatch => dispatch({
    type: DATA_CLEAR_SEARCH_RESULTS
  });
}

export function loadSearchResultsMap(params) {
  return (dispatch, getState) => {
    const queryParams = Object.assign({}, params, {
      'no-paging': null
    });

    return dispatch({
      type: GET_SEARCH_RESULTS_MAP,
      queryString: JSON.stringify(queryParams),
      meta: {
        method: 'GET',
        queryParams,
        endpoint: 'bikes/'
      }
    });
  };
}

export function clearSearchResultsMap() {
  return dispatch => dispatch({
    type: DATA_CLEAR_SEARCH_RESULTS_MAP
  });
}

export const toggleSearchBikeType = bikeType => ({
  type: DATA_SEARCH_TOGGLE_BIKE_TYPE,
  payload: { bikeType }
});

export const includeSearchBikeTypes = bikeTypes => ({
  type: DATA_SEARCH_INCLUDE_BIKE_TYPES,
  payload: {
    bikeTypes: [...bikeTypes]
  }
});

const updatePeriod = period => ({
  type: DATA_SEARCH_SET_BOOKING_PERIOD,
  payload: period
});

export const updateBeginDateTime = newBeginDateTime => (dispatch, getState) => {
  const period = updateBookingBeginDate(
      newBeginDateTime,
      selectBookingPeriod(getState())
  );

  dispatch(updatePeriod(period));
};

export const updateBeginDate = newBeginDate => (dispatch, getState) => {
  const period = updateBookingBeginDay(
    newBeginDate,
    selectBookingPeriod(getState())
  );

  dispatch(updatePeriod(period));
};

export const updateEndDateTime = newEndDateTime => (dispatch, getState) => {
  const period = updateBookingEndDate(
    newEndDateTime,
    selectBookingPeriod(getState())
  );

  dispatch(updatePeriod(period));
};

export const updateEndDate = newEndDate => (dispatch, getState) => {
  const period = updateBookingEndDay(
    newEndDate,
    selectBookingPeriod(getState())
  );

  dispatch(updatePeriod(period));
};

export const initSearchPeriod = () => updatePeriod({
  beginDateTime: getDefaultBookingDate(),
  endDateTime: getDefaultDropDate()
});

export const initSearchParams = query => {
  const {
    beginDateTime,
    endDateTime,
    bikeTypes,
    ...params
  } = extractSearchParams(query);

  const period = {
    beginDateTime: moment(beginDateTime || getDefaultBookingDate()).toISOString(),
    endDateTime: moment(endDateTime || getDefaultDropDate()).toISOString()
  };


  return {
    type: DATA_SEARCH_INIT_SEARCH,
    payload: {
      period,
      bikeTypes,
      params
    }
  };
};

export const setSearchParams = params => ({
  type: DATA_SEARCH_SET_SEARCH_PARAMS,
  payload: params
});


export const applySearchQuery = () => (dispatch, getState) => {
  const query = selectSearchQuery(getState());

  return dispatch(loadSearchResults(query));
};



// WEBPACK FOOTER //
// ./src/actions/search.js